import { Spin } from 'antd';
import type { BtlApplication } from '@api/btlApplicationForm/types';
import type { OoCaseSidebarContext } from '@components/CaseSidebar/buildOoCaseSidebar';
import { isOoCaseEditableStatus } from '@components/CaseSidebar/config/ooStatus';
import { CaseSidebarItemId } from '@components/CaseSidebar/types';
import { FormValidationProvider } from '@hooks/useBtlFormValidation';
import { BtlBaseForm } from '@pages/BtlApplicationFormPage/BtlBaseForm';
import { useNavigate } from 'react-router-dom';
import { OoCaseFormFooter } from '../OoCaseFormFooter';
import { useOoCaseExpensesForm } from './useOoCaseExpensesForm';

interface CaseExpensesPageProps {
  caseId: string;
  case?: BtlApplication;
  isCaseLoading: boolean;
  sidebarContext: OoCaseSidebarContext;
}

function CaseExpensesPageContent({ caseId, case: caseData, isCaseLoading, sidebarContext }: CaseExpensesPageProps) {
  const navigate = useNavigate();
  const form = useOoCaseExpensesForm({ caseId, caseData, isCaseLoading, sidebarContext });

  const handleNavigate = (itemId: CaseSidebarItemId) => {
    navigate({ search: `?section=${itemId}` });
  };

  if (form.isLoading) {
    return <Spin size='large' />;
  }

  return (
    <BtlBaseForm
      {...form.formProps}
      submitter={
        form.isFormEditable
          ? {
              render: ({ form: antForm }) => (
                <OoCaseFormFooter {...form.footerProps} form={antForm} isFormEditable onNavigate={handleNavigate} />
              ),
            }
          : false
      }
    />
  );
}

export function isOoExpensesFormEditable(caseData?: BtlApplication): boolean {
  return isOoCaseEditableStatus(caseData?.status);
}

export function CaseExpensesPage(props: CaseExpensesPageProps) {
  if (!isOoExpensesFormEditable(props.case)) {
    return <CaseExpensesPageContent {...props} />;
  }

  return (
    <FormValidationProvider>
      <CaseExpensesPageContent {...props} />
    </FormValidationProvider>
  );
}
